import React, { useContext } from 'react';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { IProductLine2 } from '../../../services/WebApiClient';
import { ProductLineDetaulsAdmin } from './ProductLineDetaulsAdmin';
import { ProductLineImageSetter } from './ProductLineImageSetter';
import { ProductLineProductAdmin } from './ProductLineProductAdmin';

export function SingleProductLineAdmin(props: {
    onChange: () => void;
    productLine: Readonly<IProductLine2>
}) {
    if (!props.productLine)
        throw new Error("No product Line");

    const tc = useContext(TranslationContext);


    return (
        <div >
            <h2>{tc.translator("admin edit product line header", "Rediger productlinje {name}", { name: props.productLine.defaultName })}</h2>

            <div className="container ">
                <div className="row">
                    <div className="col">
                        <ProductLineProductAdmin {...props} />
                    </div>
                    <div className="col-sm">
                        <ProductLineImageSetter {...props} />
                        <ProductLineDetaulsAdmin {...props} />
                        
                    </div>
                </div>
            </div>
        </div>
    );
}
